import { useEffect } from "react";
import Modal from "../../components/modal/modal.component";
import InputComponent from "../../components/input/input.component";
import SwitchComponent from "../../components/switch/switch.component";
import SelectComponent from "../../components/select/select.component";
import { SystemUserService } from "../../services/system-user";
import { to } from "../../polyfill";
import { useForm } from "react-hook-form";
import Button from "../../components/button/button.component";
import { AccountService } from "../../services/accounts.service";

function FormModal({ show, data, setShow }: any) {
  const defaultValues = {
    _id: "",
    name: "",
    plan: "",
    type_plan: "",
    admin: {
      name: "",
      email: "",
    },
  };

  const {
    watch,
    setValue,
    reset,
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

  const _id = watch("_id");

  const submit = async (form: typeof defaultValues) => {
    const [error, data] = await to(form._id ? AccountService.update(form) : AccountService.save(form));
    
    if (error) {
      alert(error.message);
    } else {
      setShow(true);
    }
  };

  useEffect(() => {
    if (data) {
      setValue("_id", data._id || "");
      setValue("name", data.name);
      setValue("plan", data.plan);
      setValue("type_plan", data.type_plan);
    } else {
      reset(defaultValues);
    }
  }, [data]);

  return (
    <Modal show={show}>
      <div className="modal-header">
        <h3 className="modal-title">
          {watch("_id") ? "Editar" : "Agregar"} cuenta
        </h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="mb-5">
          <InputComponent
            label="Nombre de la cuenta *"
            {...register("name", { required: true })}
            errors={errors.name}
          />
        </div>

        <div className="mb-5">
          <SelectComponent
            label="Plan *"
            {...register("plan", { required: true })}
            errors={errors.plan}
            data={[
              {
                value: "BÁSICO",
                text: "Básico",
              },
              {
                value: "PLATA",
                text: "Plata",
              },
              {
                value: "ORO",
                text: "Oro",
              },
              {
                value: "DIAMANTE",
                text: "Diamante",
              },
            ]}
          />
        </div>

        <div className="mb-5">
          <SelectComponent
            label="Tipo de pago *"
            {...register("type_plan", { required: true })}
            errors={errors.type_plan}
            data={[
              {
                value: "MENSUAL",
                text: "Mensual",
              },
              {
                value: "ANUAL",
                text: "Anual",
              },
            ]}
          />
        </div>

        {!_id && (
          <>
            <div className="mb-5">
              <InputComponent
                label="Nombre del administrador de la cuenta *"
                {...register("admin.name", { required: true })}
                errors={errors.admin?.name}
              />
            </div>

            <div className="mb-5">
              <InputComponent
                label="Correo del administrador de la cuenta *"
                {...register("admin.email", { required: true })}
                errors={errors.admin?.email}
              />
            </div>
          </>
        )}
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" type="button" onClick={setShow}>
          Cancelar
        </button>
        <Button
          className="btn btn-primary"
          disabled={!isValid}
          isLoading={isSubmitting}
          onClick={handleSubmit(submit)}
        >
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default FormModal;
